import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// --- 401 auto-refresh + 402 redirect interceptor ---
// If a request 401s, try POST /auth/refresh ONCE and replay the original request.
// If refresh fails, kick the user to /login. Never intercept the refresh call
// itself or /auth/me (used by AuthContext bootstrap).

let refreshInFlight = null;

function isAuthBootstrapUrl(url = "") {
  return url.includes("/auth/refresh") || url.includes("/auth/me") || url.includes("/auth/login") || url.includes("/auth/register");
}

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const status = err.response?.status;
    const cfg = err.config || {};
    const url = cfg.url || "";

    // 402 -> billing page (existing behaviour)
    // Stage/Live 402s (role add-on, format role, ticket/members) are handled inline by their components.
    const inlinePaywall = url.startsWith("/live/") || url.startsWith("/stage/");
    if (status === 402 && typeof window !== "undefined" && !inlinePaywall) {
      if (!window.location.pathname.startsWith("/billing")) {
        window.location.assign("/billing");
      }
      return Promise.reject(err);
    }

    // 401 -> try silent refresh, then replay once
    if (status === 401 && !cfg._retried && !isAuthBootstrapUrl(url)) {
      cfg._retried = true;
      try {
        if (!refreshInFlight) {
          refreshInFlight = api.post("/auth/refresh").finally(() => {
            refreshInFlight = null;
          });
        }
        await refreshInFlight;
        return api(cfg);
      } catch {
        if (typeof window !== "undefined") {
          const p = window.location.pathname;
          const publicPaths = ["/", "/login", "/register", "/discover"];
          if (!publicPaths.some((pp) => p === pp || p.startsWith("/product/"))) {
            window.location.assign("/login");
          }
        }
      }
    }

    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
